import React from "react";

const XIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.0384828 1L6.21586 8.72172L0 15H1.39935L6.84186 9.50354L11.2389 15H16L9.47536 6.84393L15.2614 1H13.862L8.8503 6.06211L4.80057 1H0.0394108H0.0384828ZM2.09573 1.96346H4.2825L13.9409 14.0365H11.7541L2.09573 1.96346Z"
      fill="white"
    />
  </svg>
);

export default XIcon;
